/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServiceOverviewDto } from '../../models/service-overview-dto';

export interface ApiCollectedServiceStartDateStringEndDateStringGet$Plain$Params {
  startDateString: string;
  endDateString: string;
}

export function apiCollectedServiceStartDateStringEndDateStringGet$Plain(http: HttpClient, rootUrl: string, params: ApiCollectedServiceStartDateStringEndDateStringGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ServiceOverviewDto>>> {
  const rb = new RequestBuilder(rootUrl, apiCollectedServiceStartDateStringEndDateStringGet$Plain.PATH, 'get');
  if (params) {
    rb.path('startDateString', params.startDateString, {});
    rb.path('endDateString', params.endDateString, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ServiceOverviewDto>>;
    })
  );
}

apiCollectedServiceStartDateStringEndDateStringGet$Plain.PATH = '/api/CollectedService/{startDateString}/{endDateString}';
